import { useAtomValue } from "jotai";
import { type FunctionComponent } from "react";

import { accountAtom } from "shared/lib/account";

import { useLoginDialogStateHelper } from "scmp-app/components/login-dialog/hooks";
import { usePostiesQuizContext } from "scmp-app/components/posties/quiz/contexts";
import { sendGA4Tracking } from "scmp-app/components/tracking/google-analytics-4/apis";
import { useCurrentArticleIds } from "scmp-app/lib/current-item/hooks";

import PeterImage from "./peter.png";
import {
  Container,
  ImageGround,
  ImagePeter,
  ImagePeterContainer,
  StyledButton,
  Title,
  Wrapper,
} from "./styles";

type Props = {
  className?: string;
};
export const PostiesQuizStartPage: FunctionComponent<Props> = ({ className }) => {
  const { quizStatus, setQuizStatus } = usePostiesQuizContext();
  const { currentArticleId } = useCurrentArticleIds();

  const { isLoggedIn } = useAtomValue(accountAtom);
  const { openLoginDialog } = useLoginDialogStateHelper();

  const handleStart = () => {
    if (!isLoggedIn) {
      openLoginDialog({
        destination: window.location.href,
      });
      return;
    }

    sendGA4Tracking({
      action: "click",
      category: "posties",
      customized_parameters: {
        action_type: quizStatus === "RESUME" ? "resume" : "start",
        article_id: currentArticleId,
      },
      subcategory: "quiz",
    });

    setQuizStatus?.("IN_PROGRESS");
  };

  const getMessage = () => {
    let message = {
      buttonText: "START QUIZ",
      title: "Complete the quiz to test your knowledge!",
    };

    if (quizStatus === "RESUME") {
      message = {
        buttonText: "RESUME",
        title: "You're almost done! Let's finish this",
      };
    }

    return message;
  };

  return (
    <Container className={className}>
      <Wrapper>
        <Title>{getMessage().title}</Title>
        <StyledButton onClick={handleStart} variant="button">
          {getMessage().buttonText}
        </StyledButton>
      </Wrapper>
      <ImageGround>
        <ImagePeterContainer>
          <ImagePeter src={PeterImage.src} />
        </ImagePeterContainer>
      </ImageGround>
    </Container>
  );
};

PostiesQuizStartPage.displayName = "PostiesQuizStartPage";
